import "./src/styles/global.css";
import { initEffects } from "./src/utils/effects";

export function disableCorePrefetching() {
  return true;
}

export function onRouteUpdate() {
  initEffects();
}
